import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const SearchBar = ({ searchTerm, onSearchChange, dietaryFilter, onDietaryChange }) => {
  const dietaryOptions = [
    { value: 'all', label: 'All Items' },
    { value: 'gluten-free', label: 'Gluten-Free' },
    { value: 'vegan', label: 'Vegan Options' },
    { value: 'dairy-free', label: 'Dairy-Free' },
    { value: 'nut-free', label: 'Nut-Free' }
  ];

  return (
    <div className="bg-card rounded-xl p-6 shadow-warm">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2">
          <div className="relative">
            <Input
              type="search"
              placeholder="Search by name, ingredient, or Italian term..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e?.target?.value)}
              className="pl-12"
            />
            <div className="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none">
              <Icon name="Search" size={20} color="var(--color-muted-foreground)" />
            </div>
          </div>
        </div>
        <div>
          <Select
            options={dietaryOptions}
            value={dietaryFilter}
            onChange={onDietaryChange}
            placeholder="Dietary Preferences"
          />
        </div>
      </div>
    </div>
  );
};

export default SearchBar;